// @flow

export default function genericInFunc<C: Object, R: Object>(obj: C, rec: R): C {
    return (0: any)
}
